import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TodoPackageEditor.html?raw';
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { MainCatalogTypes, MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";
import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { ExpandableSection, ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import HintBox from '../../../moreCore/UI/HintBox/HintBox';
import { SelectEntityDialogTypes } from "../../../moreCore/_loadingHelpers/SelectEntityDialog";
import MultiLangEdit from '../../../moreCore/UI/MultiLangEdit/MultiLangEdit';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
interface TodoDescriptionEntry {
    assignmentID: string;
    descriptionID: string;
    description: string;
    isDeleted?: boolean;
    isNew?: boolean;
}
interface TodoDescriptionData {
    ID: string;
    description: string;
}interface ClassEntry {
    assignmentID: string;
    class_name_1: string;
    class_display_1: string;
    isDeleted?: boolean;
}
interface ClassData {
    class_name_1: string;
    class_display_1: string;
}
class TodoPackageEditor extends compose(MainCatalogsEditorBaseV2, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private expanderTodoDescriptions: MdsLax<InstanceType<typeof ExpandableSection>>
    private selectedDescriptions: Array<TodoDescriptionEntry> = [];
    private inputTodoDescriptions: MdsLax<InstanceType<typeof HintBox>>;
    private descriptionsTable: MdsLax<InstanceType<typeof StaticTable>> = null;
    private descriptionTableContainer: HTMLElement;

    private expanderClasses: MdsLax<InstanceType<typeof ExpandableSection>>
    private selectedClasses: Array<ClassEntry> = [];
    private inputClasses: MdsLax<InstanceType<typeof HintBox>>;
    private classesTable: MdsLax<InstanceType<typeof StaticTable>> = null;
    private classesTableContainer: HTMLElement;

    private input_Description: MdsLax<InstanceType<typeof MultiLangEdit<any>>>;
    private input_Order: MdsLax<InstanceType<typeof NumberInput>>;


    isValid(): boolean {
        let isValid = true;

        isValid = this.input_Description.isValid && isValid;
        isValid = this.input_Order.isValid && isValid;

        return isValid;
    }    

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        this.selectedDescriptions = lang.clone(this.getAttributeValue("todoDescriptions"));
        this.selectedClasses = lang.clone(this.getAttributeValue("classes"));
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.TodoPackage;
    }
    private _onChangeClasses() {
        
        let value = this.inputClasses.getValue() as ClassData;

        this.addNewClassEntry(value);

        this.inputClasses.setValue(null, true);
    }

    private _onChangeTodoDescriptions() {

        let value = this.inputTodoDescriptions.getValue() as TodoDescriptionData;

        this.addNewDescriptionEntry(value);

        this.inputTodoDescriptions.setValue(null, true);
    }

    private updateDescriptionsTable() {

        let selecteDescriptions: Array<TodoDescriptionEntry> = lang.clone(this.getAttributeValue("todoDescriptions"));

        selecteDescriptions?.length > 0 ? this.expanderTodoDescriptions.setMarking(ExpandableSectionMarkings.hasContent) : this.expanderTodoDescriptions.setMarking(ExpandableSectionMarkings.default);

        this.descriptionsTable.setData(selecteDescriptions);

        selecteDescriptions?.forEach(s => {
            if (s.isDeleted === true) {
                this.disableNode(this.descriptionsTable.getRowGroupByKeyValue(s.assignmentID, "assignmentID").rows[0].node);
            }
        })
    }

    private updateClassesTable() {

        let selecteClasses: Array<ClassEntry> = lang.clone(this.getAttributeValue("classes"));

        selecteClasses?.length > 0 ? this.expanderClasses.setMarking(ExpandableSectionMarkings.hasContent) : this.expanderTodoDescriptions.setMarking(ExpandableSectionMarkings.default);

        this.classesTable.setData(selecteClasses);

        selecteClasses?.forEach(s => {
            if (s.isDeleted === true) {
                this.disableNode(this.classesTable.getRowGroupByKeyValue(s.assignmentID, "assignmentID").rows[0].node);
            }
        })
    }

    private _setUpTables(response: { layouts: Array<any> }) {

        if (this.descriptionsTable != null) this.descriptionsTable.destroy();
        if (this.classesTable != null) this.classesTable.destroy();

        this.descriptionsTable = new StaticTable();
        this.descriptionsTable.placeAt(this.descriptionTableContainer);

        this.descriptionsTable.setLayout(response.layouts[0]);
        this.descriptionsTable.addDefaultRowActionButton("delete", lang.hitch(this, this.removeDescription));
        this.descriptionsTable.setCyAttribute("TodoPackageEditorDescriptionsTable");

        //this.descriptionsTable.setRowClick(lang.hitch(this, this._onRowClick))

        this.updateDescriptionsTable();

        this.classesTable = new StaticTable();
        this.classesTable.placeAt(this.classesTableContainer);
             
        this.classesTable.setLayout(response.layouts[1]);
        this.classesTable.addDefaultRowActionButton("delete", lang.hitch(this, this.removeClass));
        this.classesTable.setCyAttribute("TodoPackageEditorClassesTable");

        //this.descriptionsTable.setRowClick(lang.hitch(this, this._onRowClick))

        this.updateClassesTable();
    }

    private removeDescription(rowGr: StaticTable.StaticTableRowGroup<TodoDescriptionEntry>) {

        let entry = rowGr.entity;
        let deletedEntry = this.selectedDescriptions.filter(x => x.descriptionID === entry.descriptionID && x.assignmentID === entry.assignmentID)[0];

        if (entry.assignmentID == null) {

            this.selectedDescriptions.splice(this.selectedDescriptions.indexOf(deletedEntry), 1);
        } else {

            deletedEntry.isDeleted = true;
        }

        this.setAttributeValue("todoDescriptions", lang.clone(this.selectedDescriptions));
        this.updateDescriptionsTable();
    }

    private removeClass(rowGr: StaticTable.StaticTableRowGroup<ClassEntry>) {

        let entry = rowGr.entity;
        let deletedEntry = this.selectedClasses.filter(x => x.class_name_1 === entry.class_name_1 && x.assignmentID === entry.assignmentID)[0];

        if (entry.assignmentID == null) {

            this.selectedClasses.splice(this.selectedClasses.indexOf(deletedEntry), 1);
        } else {

            deletedEntry.isDeleted = true;
        }

        this.setAttributeValue("classes", lang.clone(this.selectedClasses));
        this.updateClassesTable();
    }
    private addNewClassEntry(value: ClassData) {
        if (value == null) return;

        let existingEntry = this.selectedClasses.filter(x => x.class_name_1 === value.class_name_1)[0];
        if (existingEntry && existingEntry.isDeleted !== true) {
            //this.showToast(`${value.description} allready in list!`);
            this.showToast({
                title: this.translate("MainCatalogsEditor_CLASSES_Toast_ExistInList"),
                message: `**${value.class_name_1}**  ${this.translate("MainCatalogsEditor_CLASSES_Toast_ExistInList_details")}`,
                messageIcon: "fas fa-info-circle",
                iconClass: "fas fa-info-circle"
            })
            return;
        }

        if (existingEntry && existingEntry.isDeleted === true) {

            existingEntry.isDeleted = false;
            this.setAttributeValue("classes", lang.clone(this.selectedClasses));
            this.updateClassesTable();
            return;
        }

        let fakeEntry: ClassEntry = {
            assignmentID: null,
            class_name_1: value.class_name_1,
            class_display_1: value.class_display_1
        }

        this.selectedClasses.push(fakeEntry);
        this.setAttributeValue("classes", lang.clone(this.selectedClasses));

        this.updateClassesTable();
    }
    private addNewDescriptionEntry(value: TodoDescriptionData) {

        if (value == null) return;

        let existingEntry = this.selectedDescriptions.filter(x => x.descriptionID === value.ID)[0];
        if (existingEntry && existingEntry.isDeleted !== true) {
            //this.showToast(`${value.description} allready in list!`);
            this.showToast({
                title: this.translate("MainCatalogsEditor_TODODESCRIPTIONS_Toast_ExistInList"),
                message: `**${value.description}**  ${this.translate("MainCatalogsEditor_TODODESCRIPTIONS_Toast_ExistInList_details")}`,
                messageIcon: "fas fa-info-circle",
                iconClass: "fas fa-info-circle"
            })
            return;
        }

        if (existingEntry && existingEntry.isDeleted === true) {

            existingEntry.isDeleted = false;
            this.setAttributeValue("todoDescriptions", lang.clone(this.selectedDescriptions));
            this.updateDescriptionsTable();
            return;
        }

        let fakeEntry: TodoDescriptionEntry = {
            assignmentID: null,
            descriptionID: value.ID,
            description: value.description
        }

        this.selectedDescriptions.push(fakeEntry);
        this.setAttributeValue("todoDescriptions", lang.clone(this.selectedDescriptions));

        this.updateDescriptionsTable();
    }

    private _onClick_OpenSED(identifierName, evt) {

        this.loadSelectEntityDialog(evt,
            identifierName,
            lang.hitch(this, this._onCallback_Dlg)
        );
    }

    private _onCallback_Dlg(mode: string, data, items: Array<SelectEntityDialogTypes.Item<any>>) {
        // fake-entity falls das zurückgeleiferte Entity aus items[0].entry.data nicht dem entspricht das die liste erwartet

        if (!items || !items.length) return;

        switch (mode) {
            case "selectTodoDescriptions":

                for (let item of items) {
                    let entity: Partial<TodoDescriptionData> = item.entry?.data;
                    if (!entity) {
                        entity = {
                            ID: item.entry.value, description: item.entry.label
                        };
                    }
                    this.addNewDescriptionEntry(entity as any);
                }
                break;
            case "selectClasses":
                for (let item of items) {
                    let entity: Partial<ClassData> = item.entry?.data;
                    if (!entity) {
                        entity = {
                            class_name_1: item.entry.value, class_display_1: item.entry.label
                        };
                    }
                    this.addNewClassEntry(entity as any);
                }
                break;
        }
    }
    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);    

        this.inputTodoDescriptions.addInlineButton(lang.hitch(this, this._onClick_OpenSED, "selectTodoDescriptions"));
        this.inputClasses.addInlineButton(lang.hitch(this, this._onClick_OpenSED, "selectClasses"));
        this.SEDconfigCallfunction = "Webtool_API_MainCatalogsEditor__SED_GetConfig";
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.RequestManager.callfunction(
            "Webtool__MainCatalogsEditor_GetTodoPackageEditorTables",
            null,
            lang.hitch(this, this._setUpTables),
            (err) => { this.showToast(err.Message) }
        )
    }
}

export default mdsWidget(TodoPackageEditor);
